import * as tslib_1 from "tslib";
import { BehaviorSubject } from 'rxjs';
import { localPersistentStorage } from '../utils/storage';
var PersistentSubject = (function (_super) {
    tslib_1.__extends(PersistentSubject, _super);
    function PersistentSubject(storageKey, defaultValue, storage) {
        if (storage === void 0) { storage = localPersistentStorage; }
        var _this = this;
        var stored = storage.getItem(storageKey);
        var value = stored ? stored : defaultValue;
        _this = _super.call(this, value) || this;
        _this.storage = storage;
        _this.storageKey = storageKey;
        return _this;
    }
    PersistentSubject.prototype.next = function (value) {
        this.storage.setItem(this.storageKey, value);
        _super.prototype.next.call(this, value);
    };
    return PersistentSubject;
}(BehaviorSubject));
export { PersistentSubject };
//# sourceMappingURL=PersistentSubject.js.map